import React from 'react';
import { Image } from 'react-bootstrap';

const Logo = ({ small = false, dark }) => {
  return <Image src={`${process.env.PUBLIC_URL}/logo-new${dark ? '-dark' : ''}.png`} height={small ? 30 : 60} />;
};

export default Logo;
